module.exports = __webpack_public_path__ + "static/media/ARM_mid_02.36049121.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/arm/ARM_mid_02.png
// module id = 288
// module chunks = 0